import { render, staticRenderFns } from "./SearchYearRange.vue?vue&type=template&id=2810c35c"
import script from "./SearchYearRange.vue?vue&type=script&lang=js"
export * from "./SearchYearRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports